import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ArtistService from '../../services/artistService.js';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';

class GetToKnowMe extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getArtistAssociation = this.getArtistAssociation.bind(this);
        this.twitterUsername = ArtistService.getTwitterUsername(this.props.artist);
    }

    componentDidMount() {  
        if((!this.props.artist.GetToKnowMe && !this.props.artist.GetToKnowMeStatus) || this.props.artist.GetToKnowMeStatus === 'FAILED') {
            this.props.actions.getBio(this.props.artist.Username);
        }

        if (typeof (window.twttr) != 'undefined') {
            window.twttr.ready(() => {
                window.twttr.widgets.load();
            });            
        } 
    }

    getArtistAssociation(association, index) {
        let separator = index < this.props.artist.Associations.length - 1 ? ', ':'';
        return (<span key={association}>
            <Link style={{color:'#333'}} to={`/${this.props.artist.RoleType == 'Producer' ? 'Producer' : 'Artist'}s/like/${association}`} key={association}>{association}</Link>
            <span>{separator}</span>
        </span>);
    }

    render() {
        const artist = this.props.artist;
        return (
            artist.GetToKnowMeStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load bio." />
                :
                <div>
                    <article className="body biotext">
                        {
                                artist.Location ?
                                <span style={{paddingBottom:'10px', display:'block'}}>
                                    <span style={{color:'#333'}}><b>LOCATION: </b></span> 
                                    {artist.Location}
                                </span> : null                        
                        }
                        {
                            artist.WebsiteUrl ?
                            <span style={{paddingBottom:'10px', display:'block'}}>
                                <span style={{color:'#333'}}><b>WEBSITE: </b></span> 
                                <a style={{color:'#333'}} href={artist.WebsiteUrl} target="_blank" rel="nofollow">{artist.WebsiteUrl}</a>
                            </span> : null
                        }
                        {
                            artist.Associations && artist.Associations.length ?
                            <span style={{paddingBottom:'10px', display:'block'}}>
                                <span style={{color:'#333'}}><b>{artist.RoleType == 'Fan' ? 'FAVOURITE ARTISTS: ':'INFLUENCES: '}</b></span>
                                {
                                    artist.Associations.map(this.getArtistAssociation)
                                }                                          
                            </span> : null
                        }
        
                        <span style={{color:'#333', display:'block'}}><b>BIO:</b></span>
                        {artist.GetToKnowMe && artist.GetToKnowMe.length ? 
                            artist.GetToKnowMe.map((text, index) => {
                                return <p key={index}>{text}</p>;
                            }) 
                            : 
                            (artist.GetToKnowMeStatus === 'LOADING' ?
                            <Loading /> : <p>Coming soon...</p>)
                        }
                        {
                            artist.TwitterUsername ?
                                <div>
                                    <span style={{color:'#333', display:'block', paddingBottom:'5px'}}><b>RECENT TWEETS:</b></span>
                                    <a className="twitter-timeline" href={`https://twitter.com/${this.twitterUsername}`} width="500" data-widget-id="514496641823277056" data-screen-name={this.twitterUsername} data-show-replies="false" data-tweet-limit="5" data-chrome="noheader" target="_blank">Tweets by {artist.TwitterUsername}</a>
                                </div>
                                :null
                        }   
                    </article>
                </div>
        );
    }
}

GetToKnowMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default GetToKnowMe;